import { CheckboxSizeEnum } from '~/src/components/form-components/checkbox/checkbox.types';

export const checkboxSizes = {
    [CheckboxSizeEnum.SMALL]: 16,
    [CheckboxSizeEnum.MEDIUM]: 24,
    [CheckboxSizeEnum.LARGE]: 32,
};
